import React from "react";
import PretendardText from "./../../../../component/atoms/text/pretendardText";

const TimeCustomTooltip = ({ active, payload }) => {
  // 스타일 객체
  const circleStyle = {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
  };

  const incrementTimeString = (timeString) => {
    // 숫자 부분만 추출
    let numberPart = parseInt(timeString.slice(0, 2), 10);

    let newTimeString = "";

    if (numberPart === 23) {
      // 23시일 경우 00시로 변경
      newTimeString = "00시";
    } else {
      // 1 더하기
      numberPart += 1;

      // 2자리 문자열로 변환
      newTimeString = String(numberPart).padStart(2, "0") + "시";
    }

    return newTimeString;
  };

  if (active && payload && payload.length) {
    return (
      <div
        style={{
          width: "fit-content",
          height: "fit-content",
          backgroundColor: "#313233",
          padding: "10px 12px",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          boxShadow: "1px 1px 4px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <p
          style={{
            fontFamily: "Pretendard",
            fontWeight: 600,
            fontSize: "13px",
            lineHeight: "22.75px",
            color: "#f3f3f3",
            marginBottom: "8px",
          }}
        >
          {payload[0].payload.time}-
          {incrementTimeString(payload[0].payload.time)}
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: "#cf6679",
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              {payload[0].value.toLocaleString()}
            </PretendardText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: "#b658ff",
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              {payload[1].value.toLocaleString()}
            </PretendardText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: "#34f3ff",
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              {payload[2].value.toLocaleString()}
            </PretendardText>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default TimeCustomTooltip;
